import {ActionTree} from "vuex";
import {RootState} from "../types/RootState";
import {ProgramState} from "../types/ProgramState";
import {ProgramDataHelper} from "../../../share/program/helpers/ProgramDataHelper";
import {DateTime} from "luxon";
import {Meeting} from "@api/models/meetings/Meeting";
import Vue from 'vue';
import {dateInOriginalOffset} from "../../../common/dateTimeHelper";
import i18n from "../../locale/i18";

export const actions: ActionTree<ProgramState, RootState> = {
    async initialize({dispatch, commit, state, rootState, getters}, {repositories, date, store}) {
        if (rootState.webConferenceRecordingEventId) {
            return;
        }

        dispatch("showSpinner", null, { root: true})
        const dateStr = dateInOriginalOffset(date, (rootState as any).timeZoneOffset).toISODate();
        if (!state.programs[dateStr]) {
            const dataHelper = Vue.observable(new ProgramDataHelper(
                (rootState as any).events.selected,
                repositories,
                store,
                i18n
            ));
            dataHelper.date = date;
            await dataHelper.fetchData();
            commit('setProgram', {program: dataHelper, date: dateStr});
        }
        else if (state.programs[dateStr].isExpired) {
            await state.programs[dateStr].fetchData();
        }

        commit('setCurrentDate', date);

        dispatch("hideSpinner", null, { root: true })
    },
    updateCurrentDate({commit}, date: DateTime) {
        commit('setCurrentDate', date);
    },
    reset({commit, state}) {
        const object = state.programs;

        for (const key in object) {
            if (Object.prototype.hasOwnProperty.call(object, key)) {
                const element = object[key];
                element.signalRHelper.disconnect()
            }
        }

        commit('resetPrograms');
    },
    setSavedMeeting({commit}, meeting: Meeting) {
        commit('setSavedMeeting', meeting);
    }
};

